import { Activity, ActivityReducers } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { addDataHolder } from "../actions";

export const addDataHolderReducer: ActivityReducers.DataReducer = {
	reduce(dataHolders, action) {
		if (!addDataHolder.match(action)) {
			return dataHolders;
		}

		const descriptor = action.payload.dataHolder.descriptor;
		if (dataHolders?.some(Activity.DataHolder.hasDescriptor(descriptor))) {
			return dataHolders;
		}

		return [...(dataHolders ?? []), action.payload.dataHolder];
	}
};
